import { Toast } from 'vant'
export default {
    methods: {
        // 取消约车订单
        cancelBookingOrder(id, orderStatue) {
            return new Promise((resolve) => {
                this.$api.ganganCheckBreak({ orderId: id }).then(res => {
                    if (res.status) {
                        let { message, hasBreak, coachName, coachPlateNumber, courseCount, orderAmount, scheduleDate, scheduleStartTime, scheduleEndTime } = res.result
                        const start = this.moment.formatTime(scheduleStartTime, 'HH:mm')
                        const end = this.moment.formatTime(scheduleEndTime, 'HH:mm')
                        const days = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
                        const week = days[new Date(scheduleDate).getDay()];

                        const str = `<div class="booking-goods">
                            <div class="coach">
                            <div class="coach_name">${coachName}</div>
                            <div class="coach_car_number">${coachPlateNumber}</div>
                            </div>
                            <div class="info">
                            <div class="info_week">${week}&nbsp;&nbsp;&nbsp;&nbsp;${scheduleDate}</div>
                            <div class="info_timer">
                                <div class="info_timer_hour">${start} ~ ${end}</div>
                                <div class="info_timer_price">${courseCount}课时<br />${orderAmount}元</div>
                            </div>
                            </div>
                        </div>`;
                        this.dialogData = {
                            visible: true,
                            rightBtnName: '确定',
                            leftBtnName: '取消',
                            leftBtnMethod: () => {
                                this.dialogData.visible = false
                            },
                            rightBtnMethod: () => {
                                this.loading = true
                                this.dialogData.visible = false
                                this.$api.ganganBookingCancelOrder({
                                    cancelType: hasBreak ? 1 : 0,
                                    orderId: id
                                }).then(res => {
                                    Toast(res.message)
                                    if (res.status) {
                                        resolve()
                                    }
                                    this.loading = false
                                })
                            },
                            title: '提示',
                            content: orderStatue !== 0 ?  `${message.replace(/\n/g, '<br />')}${str}` : '预约练车订单是否取消？'
                        }
                    }
                })
            })
        },
        // 申请余额支付退款
        applyPayRefund(id) {
            return new Promise((resolve) => {
                this.$api.ganganCheckPayApplyRefund({ orderId: id }).then(res => {
                    if (res.status) {
                        const { message, hasBalance } = res.result
                        if (!hasBalance) {
                            Toast(message)
                            return
                        }
                        this.dialogData = {
                            visible: true,
                            rightBtnName: '确定',
                            leftBtnName: '取消',
                            leftBtnMethod: () => {
                                this.dialogData.visible = false
                            },
                            rightBtnMethod: () => {
                                this.loading = true
                                this.dialogData.visible = false
                                this.$api.ganganConfirmRefund({
                                    orderId: id
                                }).then(res => {
                                    if (res.status) {
                                        resolve()
                                    } else {
                                        Toast(res.message)
                                    }
                                    this.loading = false
                                })
                            },
                            title: '提示',
                            content: message.replace(/\n/g, '<br />')
                        }
                    }
                })
            })
        },
        // 取消余额充值订单
        cancelPayOrder (id) {
            return new Promise((resolve) => {
                this.dialogData = {
                    visible: true,
                    rightBtnName: '确定',
                    leftBtnName: '取消',
                    leftBtnMethod: () => {
                        this.dialogData.visible = false
                    },
                    rightBtnMethod: () => {
                        this.loading = true
                        this.dialogData.visible = false
                        this.$api.gangAnPlanOrderCancel({ orderId: id }).then(res => {
                            Toast(message)
                            if (res.status) {
                                resolve()
                            }
                            this.loading = false
                        })
                    },
                    title: '提示',
                    content: '确定取消订单吗？'
                }
            })
        },
        getStudyDriveDetail (id) {
            return new Promise((resolve) => {
                this.$api.getStudyDriveOrderDetail({ orderId: id }).then(res => {
                    if (res.status) {
                        resolve(res.result)
                    }
                })
            })
        },
        // 去支付
        studyDriveToPay ({ id, paymentMethod, paymentAmount }) {
            return new Promise((resolve) => {
                const payType = {
                    2: 1, // 微信
                    3: 2 // 支付宝
                }[paymentMethod]
                this.$api.ganganContinuePayOrder({ orderId: id, payAmount: paymentAmount, payType }).then(res => {
                    this.payLoading = false
                    if (res.status && res.code === '200') {
                        const { result } = res
                        if (paymentMethod === 2) { // 微信支付
                            this.$jsBridge.callBackHandler('payByStringCode', { paymentStringCode: JSON.stringify(result.wxPayAppOrderResult), payWay: 2 });
                        } else if (paymentMethod === 3) { // 支付宝支付
                            this.$jsBridge.callBackHandler('payByStringCode', { paymentStringCode: result.alipayBody, payWay: 1 });
                        }
                        // 支付成功的回调
                        this.$jsBridge.registerHandler('payCallback', (status) => {
                            if (status === '1') {
                                resolve()
                            } else {
                                Toast('支付失败，请重新支付！')
                            }
                        });
                        // 余额支付成功
                        if (paymentMethod === 1) {
                            resolve();
                        }
                    } else {
                        Toast(res.message)
                    }
                })
            })
            
        },
        handleToStudyDriveHistory () {
            location.href = `/ui/common-h5/bbjd-app/reservation-study-drive/v1/history/index?hideNav=1`;
        }
    }
}